import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import AppPage from '@/shared/components/PageComponents/AppPage';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';
import { useUserStateContext } from '@/shared/components/UserStateProvider';
import { useSnackbar } from 'notistack';
import useUpdateOrgMutation from '@/features/settings/hooks/useUpdateOrgMutation';
import { OrgLogoUpload } from './OrgLogoUpload';
import { OrgNameForm } from './OrgNameForm';
import PageHeader from '@/shared/components/PageHeader';

const OrgManagementPage = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { currentOrg } = useUserStateContext();
  const updateOrgMutation = useUpdateOrgMutation();

  const title = 'Organization Settings';
  useDocumentTitle(title);

  const handleUpdateName = async (name: string) => {
    try {
      await updateOrgMutation.mutateAsync({ name });
      enqueueSnackbar('Organization name updated', { variant: 'success' });
    } catch {
      enqueueSnackbar('Failed to update organization name', { variant: 'error' });
    }
  };

  return (
    <AppPage title={title} requiredPermissions={['menu:manage:org']}>
      <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
        <PageHeader title={title} subtitle="Manage your organization's name and logo" />

        {/* No tabs: with the Cloud Provider panel gone there is only one panel
            left, and a single-tab tab bar is chrome around nothing. The logo and
            name forms sit directly on the page. */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 640 }}>
          <OrgLogoUpload
            logoPath={currentOrg?.logoPath}
            orgName={currentOrg?.name ?? ''}
            onSuccess={() => enqueueSnackbar('Organization logo updated', { variant: 'success' })}
            onDelete={() => enqueueSnackbar('Organization logo removed', { variant: 'success' })}
          />
          <OrgNameForm initialName={currentOrg?.name} onSubmit={handleUpdateName} />
        </Box>
      </Container>
    </AppPage>
  );
};

export default OrgManagementPage;
